import { Injectable } from '@angular/core';
import { Customer } from '../models/customer.model';
import { Subject } from 'rxjs';
import { Appointment } from '../models/appointment.model';
import { Horse } from '../models/horse.model';
import { Address } from '../models/address.model';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  constructor() { }

  private eventSubject = new Subject<any>();
  event$ = this.eventSubject.asObservable();

  mode?: 'new-horse' | 'new-address' | "edit-horse" | "edit-address"
  open = false
  title?: string = ""

  public customer?: Customer
  public horse?: Horse
  public address?: Address

  openNewHorseModal(horse?: Horse){
    this.horse = horse
    this.mode = (horse && horse.id) ? "edit-horse" : "new-horse"
    this.title = (this.mode === "new-horse") ? "Create Horse" : "Edit Horse"
    this.open = true
  }

  openNewAddressModal(appointmet: Appointment){
    this.customer = appointmet.customer
    this.mode = "new-address"
    this.title = "Create Address"
    this.open = true
  }

  openEditAddressModal(address: Address){
    this.address = address
    this.mode = "edit-address"
    this.title = "Edit Address"
    this.open = true
  }

  dismiss(){
    this.mode = undefined
    this.address = undefined
    this.horse = undefined
    this.open = false
    
  }

  broadcastEvent(event: any) {
    this.eventSubject.next(event);
  }

}
